import { createHtmlElement } from '../../../functions';
import Masonry from 'masonry-layout';
import { changeLangToCurrent, getCurrentLang, getCurrentLangDirection } from '../../language/langSwitcher';
import { pageResize } from '../../menu/menu';
import { settingsData } from '../../../settings';
import { checkCRM, showErrorPage } from './galleryMobile';
import {Disclaimer} from "../../disclaimer/Disclaimer";

let masonry, dir;

const fancyBoxTemplate =`
<div class="fancybox-container" role="dialog" tabindex="-1">
<div class="fancybox-bg"></div>
<div class="fancybox-inner">
<div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div>
<div class="fancybox-toolbar">{{buttons}}</div>
<div class="fancybox-navigation">{{arrows}}</div>
<div class="fancybox-stage"></div>
<div class="fancybox-caption langDirection "><div class="fancybox-caption__body"></div></div>
</div>
</div>`;


export function galleryDesktop (response) {
  const mainContainer = createHtmlElement(document.body,'','div',['widget__container','desktop__gallery']);
  mainContainer.dataset.menuItem = 'gallery';

  const galleryContainer = createHtmlElement(mainContainer,'','div',['gallery__main-container']);

  const disclaimer = new Disclaimer(galleryContainer);
  disclaimer.text = 'Pictures for illustration only';
  disclaimer.addClass('gallery-disclaimer');


  const isData = checkCRM(response);
  if (!isData){
    showErrorPage(galleryContainer);
    pageResize(mainContainer);
    return;
  }

  // response.data[0].pictures[0].imageUrl = 'https://threejs.org/examples/textures/pano.webm';

  const styleArray = ['grid-item--height2','grid-item--height3','grid-item--height4','grid-item--height5'];
  const fancyboxMainContainer = createHtmlElement(document.body,'','div',['fancybox__main-container']);
  const fancyboxWrapper = createHtmlElement(fancyboxMainContainer,'','div',['fancybox__wrapper']);

  const menuContent = createHtmlElement(galleryContainer,'','div',['menu-content__wrapper','gallery__menu-content__wrapper']);
  const tabs = createHtmlElement(menuContent,'','div',['gallery__tabs']);
  const container = createHtmlElement(galleryContainer,'','div',['gallery','grid']);
  container.setAttribute('id','lightGallery');
  const currentLang = getCurrentLang();

  pageResize(mainContainer);

  let count = 0;

  const containerWidth = container.getBoundingClientRect().width;
  const { columnCount, gutter } = settingsData.desktopGallery;
  const gridColumnWidth = Math.floor(containerWidth / columnCount) - gutter;

  response.data.forEach(category =>{
    const tab = createHtmlElement(tabs,'','button',['gallery__tab__btn','language-string']);
    let categoryName;

    category.name.forEach(name => {

      if (name.lang === getCurrentLang()) tab.textContent = name.value;
      if (name.lang === 'en') categoryName = name.value;

      tab.setAttribute(`data-lang-${name.lang}`,name.value);
    });

    tab.dataset.category = categoryName;
    tab.dataset.active = 'true';
    // tab.setAttribute('data-dictionary', categoryName);

    category.pictures.forEach((picture, index) =>{

      const item = createHtmlElement(container,'','a',['grid-item']);
      const captionText = picture.title.filter(text => text.lang === getCurrentLang())[0].value;
      item.dataset.caption = captionText;
      item.dataset.captionObject = JSON.stringify(picture.title);
      item.style.width = gridColumnWidth + 'px';
      item.setAttribute('fancybox','gallery');
      item.dataset.indexCount = count;
      let content;

      const isPucture = picture.imageUrl.match(/(.jpg)|(.png)|(.jpeg)/g);

      if (isPucture){
        item.href = reduceImage(picture.imageUrl,{
          width: 2880,
          quality: 90
        });

        content = createHtmlElement(item,'','img',['gallery__image']);
        content.src = reduceImage(picture.imageUrl,{
          width: 1024,
          quality: 75
        });
      } else {
        content = createHtmlElement(item,'','video',['gallery__video']);
        content.src = picture.imageUrl + '#t=0.5';
        item.href = picture.imageUrl;
        item.classList.add('icon-play');
      }

      item.dataset.categoryName = categoryName;
      if (index % 2){
        const randomClass = styleArray[getRandom(0, styleArray.length - 1)];
        item.classList.add(randomClass);
      }

      content.dataset.categoryName = categoryName;
      content.dataset.indexCount = count;

      count++;
    });
  });

  masonry = new Masonry( container, {
    itemSelector: '.grid-item',
    stagger: 30,
    fitWidth: true,
    columnWidth: gridColumnWidth,
    gutter: gutter,
  });

  container.addEventListener('click',(e)=>{
    e.preventDefault();
    openGallery(e,fancyboxMainContainer);
  });

  masonry.userData = {};
  masonry.userData.hidedElements = [];

  window.masonry = masonry;

  tabs.addEventListener('click', tabsHandler);
}

export function updateDesktopGallery () {
  const gallery = document.querySelector('.desktop__gallery');
  if (!gallery){
    return;
  }
  pageResize(gallery);
}

function openGallery ({target},galleryContainer) {
  let targetElement;

  if (target.classList.contains('grid')){
    return;
  } else if (target.classList.contains('gallery__video') || (target.classList.contains('gallery__image'))){
    targetElement = target.parentElement;
  } else if (target.classList.contains('grid-item')){
    targetElement = target;
  }

  const allPictures = masonry.getItemElements();
  const visiblePictures = allPictures.filter(picture => picture.style.display !=='none');

  const selectedIndex = visiblePictures.findIndex(item => item === targetElement);
  const parsedArray = prepareImagesForFancyboxGallery(visiblePictures);

  dir = getCurrentLangDirection();

  $.fancybox.open(parsedArray,{
    parentEl: galleryContainer.querySelector('.fancybox__wrapper'),
    infobar: false,
    idleTime: false,
    animationEffect: 'fade',
    backFocus: false,
    animationDuration: 150,
    buttons: [
      "zoom",
      //"share",
      // "slideShow",
      //"fullScreen",
      //"download",
      // "thumbs",
      "close"
    ],
    btnTpl:{
      zoom: '<button data-fancybox-zoom class="fancybox-button fancybox-button--zoom' +
        ' full-screen__zoom__desktop"></button>',
    },
    baseTpl: fancyBoxTemplate.replace('langDirection', dir),
    afterClose: ()=>{
      closeGallery();
    },
    // beforeShow: ()=>{
    //   console.log('before show');
    // }

  },selectedIndex);


  galleryContainer.classList.add('show-fancybox-gallery');
}

function getActiveCategory () {
  const tab = document.querySelector('.gallery__tab__btn[data-active="true"]');
  if (!tab){
    return;
  }

  return tab.dataset.category;
}

function prepareImagesForFancyboxGallery (arrayOfHtmlElements) {
  const parseArray = [];

  for (let el of arrayOfHtmlElements){

    const captionObject = JSON.parse(el.dataset.captionObject);
    const captionText = captionObject.filter(caption => caption.lang === getCurrentLang())[0].value;

    const obj = {
      src: el.href,
      opts: {
        caption: captionText,
        thumb: el.href
      }
  };

    parseArray.push(obj);
  }

  return parseArray;
}

function closeGallery () {
  const container = document.querySelector('.fancybox__main-container');
  container.classList.remove('show-fancybox-gallery')
  $.fancybox.destroy();
}

function updateLayout () {
  // setTimeout(()=>{
    masonry.layout();
    console.log('layout - updated');
  // },1000);
}

function tabsHandler ({target}) {
  if (target.dataset.category){
    const validate = validateTabs(target);

    if (!validate){
      return;
    }

    const selectedCategory = target.dataset.category;
    setActiveCategory(selectedCategory);
    const categoriesNames = getActiveCategoriesNames();

    if (isElementsHidden()){
      showHiddenElements(getHiddenElements());
    }

    const items = masonry.getItemElements();
    const sorted = items.filter(item => !categoriesNames.includes(item.dataset.categoryName));

    hideElements(sorted);

    updateLayout();
  }

}

function validateTabs (target) {
  const activeTabs = document.querySelectorAll(`.gallery__tab__btn[data-active="true"]`);

  if (activeTabs.length >=2){
    return true;
  } else if (activeTabs[0] === target){
    return false;
  } else if (activeTabs[0] !== target){
    return true;
  }
}

function setActiveCategory (category) {
  const selectedCategory = document.querySelector(`.gallery__tab__btn[data-category="${category}"]`);

  if (selectedCategory.dataset.active === 'true'){
    selectedCategory.dataset.active = 'false';
  } else {
    selectedCategory.dataset.active = 'true';
  }
}

function getActiveCategoriesNames () {
  const categoriesNames = [];
  const categories = document.querySelectorAll(`.gallery__tab__btn[data-active="true"]`);

  categories.forEach(category =>{
    categoriesNames.push(category.dataset.category);
  });

  return categoriesNames;
}

function resetHidden () {
  masonry.userData.hidedElements = [];
}

function hideElements (elements) {
  resetHidden();
  masonry.userData.hidedElements = elements;
  // masonry.hideItemElements(elements);
  elements.forEach(el => el.style.display = 'none');
}

function getHiddenElements () {
  return masonry.userData.hidedElements;
}

function isElementsHidden () {
  return Boolean(masonry.userData.hidedElements.length);
}

function showHiddenElements (elements) {
  masonry.revealItemElements(elements || masonry.userData.hidedElements);
  masonry.userData.hidedElements = [];
}

function getRandom(min, max) {
    return Math.round(Math.random() * (max - min) + min);
}

export function reduceImage (url,params = {}) {
  if (!Object.keys(params).length){
    return url;
  }

  const width = params.hasOwnProperty('width') ? params['width'] : 1024;
  const quality = params.hasOwnProperty('quality') ? params['quality'] : 100;
  const paramsValues = `width=${width},quality=${quality}`;

  const reduceImgUrl = `cdn-cgi/image/${paramsValues}`;
  const parseUrl = url.replace('https://','').split('/');
  parseUrl.unshift('https:/');
  parseUrl.splice(2,0,reduceImgUrl);
  const buildUrl = parseUrl.join('/');

  return buildUrl;
}
